import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { Container, Dropdown, Row, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FiUnlock } from "react-icons/fi";
import { FiLogOut } from "react-icons/fi";
import Profile from "../../Assets/Images/Profile-icon.png";
const Layout = ({ children }) => {
  const [show, setShow] = useState(false);
  const [isActive, setIsActive] = useState(false);
  return (
    <div>
      <div className="main-wrap">
        <div className={show ? "left-side hide" : "left-side "}>
          <Sidebar
            isActive={isActive}
            setIsActive={setIsActive}
            show={show}
            setShow={setShow}
          />
        </div>
        <div className={show ? "right-side-cmn hide" : "right-side-cmn "}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
